/**
 * Canonical NECS staff agent shift schedule.
 *
 * Source of truth for every dashboard, scheduling form, swap request,
 * and Add-Employee dialog. Shifts are keyed by stable `shift_code`
 * strings — never rename keys, only add new ones — so historical
 * schedules in MongoDB keep resolving correctly.
 *
 * Updated Feb 2026 (PhD directive):
 *   morning        7:30 AM  – 4:30 PM   (day cleaning crews)
 *   afternoon      2:00 PM  – 11:00 PM  (mixed)  [was 3:00 PM start]
 *   evening        5:00 PM  – 2:00 AM   (peak valet trash) [was 6:00 PM start]
 *   evening_late   5:30 PM  – 2:30 AM   (NEW — staggered peak coverage)
 *   late_evening   6:30 PM  – 11:30 PM  (standard valet)
 *   night          7:30 PM  – 1:30 AM   (late valet)
 */

export const STAFF_SHIFTS = {
  shift_early_morning: { name: 'Early Morning', start: '5:00 AM', end: '2:00 PM', duration: '9 hours', crossesMidnight: false, start24: '05:00', end24: '14:00' },
  shift_morning:       { name: 'Morning',        start: '7:30 AM',  end: '4:30 PM',  duration: '9 hours' },
  shift_afternoon:     { name: 'Afternoon',      start: '2:00 PM',  end: '11:00 PM', duration: '9 hours' },
  shift_evening:       { name: 'Evening',        start: '5:00 PM',  end: '2:00 AM',  duration: '9 hours' },
  shift_evening_late:  { name: 'Evening (Late)', start: '5:30 PM',  end: '2:30 AM',  duration: '9 hours' },
  shift_late_evening:  { name: 'Late Evening',   start: '6:30 PM',  end: '11:30 PM', duration: '5 hours' },
  shift_night:         { name: 'Night',          start: '7:30 PM',  end: '1:30 AM',  duration: '6 hours' },
  shift_overnight:     { name: 'Overnight',      start: '7:30 PM',  end: '4:30 AM',  duration: '9 hours', crossesMidnight: true, start24: '19:30', end24: '04:30' },
  shift_overnight_late: { name: 'Overnight (Late)', start: '8:30 PM', end: '5:30 AM', duration: '9 hours', crossesMidnight: true, start24: '20:30', end24: '05:30' },
};

// Ordered list for dropdowns / pickers — chronological by start time
// so agents scan the list in the same order the workday flows.
export const STAFF_SHIFT_ORDER = [
  'shift_early_morning',
  'shift_morning',
  'shift_afternoon',
  'shift_evening',
  'shift_evening_late',
  'shift_late_evening',
  'shift_night',
  'shift_overnight',
  'shift_overnight_late',
];

// Convenient label like "Afternoon · 2:00 PM – 11:00 PM"
export function shiftLabel(code) {
  const s = STAFF_SHIFTS[code];
  if (!s) return code || '—';
  return `${s.name} · ${s.start} – ${s.end}`;
}

// Default shift assigned to brand-new staff agents.
export const DEFAULT_STAFF_SHIFT = 'shift_late_evening';
